<template>
  <NuxtLayout name="funnel">
    <CottageContactDeal
      v-if="cottageDealPage"
      :cottage-contact-deal-page="cottageDealPage"
    />
  </NuxtLayout>
</template>

<script setup lang="ts">
// Fetchers
import fetchRuralityDeal from '~/modules/api/rurality/v3/cottage-deals/deal'

import type { CottageContactDealPage } from '~/modules/views/cottage-contact-deal/entities/CottageContactDealPage'

import type { HeadInfo } from '~/modules/head/entities/HeadInfo'
import { useHeadInfoComposable } from '~/modules/head/composables/useHeadInfoComposable'

const { setHeadInfo } = useHeadInfoComposable()
const { t } = useI18n({})
const route = useRoute()

definePageMeta({
  menuLogoBackHideLink: true,
})

const showErrorPage = (error: ApiResponseError) => {
  throw createError({
    statusCode: 503,
    message: error.message,
    fatal: true,
  })
}

const setTitle = (cottage: CottageContactDealPage): string => {
  return t('views.cottage-contact-deal.seo.title', { name: cottage.name })
}

/* CONSTANTS */
const slug = route.params.slug as string
const province = route.params.province as string
const dealId = route.params.id as string

const paramsCottage = { slug, province }

let cottageDealPage: CottageContactDealPage | null = null

const { data: cottageData } = await useFetch(
  '/__nuxt-api/rurality/v3/cottages/detail',
  {
    body: paramsCottage,
    method: 'POST',
  },
)

if (cottageData.value) {
  if (cottageData.value.success) {
    const getCottageCall = cottageData.value.success.data

    const paramsOwner = {
      id: getCottageCall.owner.id,
    }
    const { data: ownerData } = await useFetch(
      '/__nuxt-api/rurality/v3/owners/detail',
      {
        body: paramsOwner,
        method: 'POST',
      },
    )

    if (ownerData.value) {
      if (ownerData.value.success) {
        const dealData = await fetchRuralityDeal({
          id: dealId,
        })

        if (dealData.success) {
          cottageDealPage = {
            ...getCottageCall,
            owner: ownerData.value.success.data,
            deal: dealData.success.data,
          }
          const cottageHeadInfo: HeadInfo = {
            title: setTitle(cottageDealPage),
          }
          setHeadInfo(cottageHeadInfo)
        } else if (dealData.error) {
          showErrorPage(dealData.error as ApiResponseError)
        }
      } else if (ownerData.value.error) {
        showErrorPage(ownerData.value.error as ApiResponseError)
      }
    }
  } else if (cottageData.value.error) {
    showErrorPage(cottageData.value.error as ApiResponseError)
  }
}
</script>
